module.exports = __webpack_public_path__ + "media/taVideo1.26021815.mp4";